import { Injectable } from '@angular/core';
import { StringHelpers } from '@mode/shared/util-js';
import _ from 'lodash';
import { ModeModelBase } from '../model';
import { ModelAccessorBase, ModelAccessorInjectables } from '../model_accessor';

const buildMembership = (spaceMembership) => {
  return spaceMembership.member().then((member) => {
    spaceMembership.accountMember = member;
    return spaceMembership;
  });
};

export class SpaceMembershipModel extends ModeModelBase {
  override _name = 'spaceMembership';
  member_type: any;

  override idAttribute = 'token';
  override belongsTo = 'space';
  override parentIdAttribute = 'token';
  override attributes = [
    { name: 'email', default: '' },
    { name: 'member_token', default: '' },
    { name: 'member_type', default: 'account' },
    { name: 'member_id', default: '' },
  ];
  override hasPoly = [{ name: 'member', id: 'member_id', type: 'member_type' }];

  override initialize(resource: any): void {
    this.initEmbedded('member', StringHelpers.camalize(this.member_type), false);
  }
}

@Injectable({ providedIn: 'root' })
export class SpaceMembershipModelAccessor extends ModelAccessorBase<SpaceMembershipModel> {
  override name = 'spaceMembership';
  override idAttribute = 'token';
  override parentModel = 'space';
  override parentIdAttribute = 'token';
  override createAttributes = ['space'];

  constructor(injectables: ModelAccessorInjectables) {
    super(injectables, 'migrated', 'mode.spaceMembership');
  }

  buildMembershipsWithAccount(spaceMemberships) {
    return this.injectables.$q.all(_.map(spaceMemberships, buildMembership));
  }
  createModel(resource, opts?) {
    const model = new SpaceMembershipModel(this.injectables.modelInjectables);
    model.$initialize(resource, opts);
    return model;
  }
}
